<template>
  <div class="my-serviceorder">
    <!-- 设备列表 -->
    <div class="device-list">
      <div
          class="device-item"
          :class="{ active: activeDeviceSn === '' }"
          @click="changeDevice('')"
      >
        <div class="sn">全部设备</div>
      </div>
      <div
          v-for="item in deviceList"
          :key="item.deviceSn"
          :class="['device-item', activeDeviceSn === item.deviceSn ? 'active' : '']"
          @click="changeDevice(item.deviceSn)"
      >
        <div class="sn">{{ item.deviceSn }}</div>
        <div class="store">{{ item.storeName || '' }}</div>
        <div class="rate">分润 {{ (item.profitRate * 100).toFixed(2) }}%</div>
      </div>
    </div>

    <!-- 下拉刷新 + 订单列表 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="order-box">
        <div class="order-num">订单数：{{ total }}</div>

        <div v-if="orderList.length === 0 && !loading" class="empty-tip">
          暂无订单
        </div>

        <div class="order-detail" v-for="item in orderList" :key="item.orderSn">
          <div class="detail-left">
            <div class="ms-box">订单号：{{ item.orderSn }}</div>
            <div class="ms-box">门店：{{ item.rentStoreName }}</div>
            <div class="ms-box">状态：{{ formatStatus(item.status) }}</div>
            <div class="ms-box">创建时间：{{ formatTime(item.createTime) }}</div>
          </div>
          <div class="detail-right">
            <div class="jg-right">￥{{ item.profitAmount }}</div>
            <div class="ms-right">分润</div>
          </div>
        </div>

        <div
            class="order-more"
            v-if="!finished && orderList.length > 0"
            @click="loadMore"
        >
          加载更多...
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  name: "MyServiceOrder",
  data() {
    return {
      deviceList: [],
      activeDeviceSn: "",

      orderList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,

      loading: false,
      finished: false,
      refreshing: false,
      lock: false,
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      await this.loadDevices();
      await this.loadOrders(true);
    },

    async loadDevices() {
      try {
        const res = await this.$http.getServiceCustomOrders({ pageNum: 1, pageSize: 1 });
        if (res.code === 200) {
          this.deviceList = res.deviceList || [];
        }
      } catch (e) {
        console.error("设备列表请求失败", e);
      }
    },

    async loadOrders(reset = false) {
      if (this.lock) return;
      this.lock = true;

      if (reset) {
        this.pageNum = 1;
        this.finished = false;
        this.orderList = [];
      }

      this.loading = true;
      try {
        const res = await this.$http.getServiceCustomOrders({
          deviceSn: this.activeDeviceSn,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        });

        if (res.code === 200) {
          let list = res.orderList || [];
          // 格式化时间
          list = list.map((item) => ({
            ...item,
            createTime: this.formatTime(item.createTime),
          }));

          this.orderList = reset ? list : this.orderList.concat(list);
          this.total = res.total || 0;
          this.pageNum++;
          this.finished = this.orderList.length >= this.total;
        }
      } catch (e) {
        console.error("订单列表请求失败", e);
      } finally {
        this.lock = false;
        this.refreshing = false;
        this.loading = false;
      }
    },

    changeDevice(deviceSn) {
      if (this.activeDeviceSn === deviceSn) return;
      this.activeDeviceSn = deviceSn;
      this.loadOrders(true);
    },

    onRefresh() {
      this.loadOrders(true);
    },

    loadMore() {
      if (!this.finished) this.loadOrders();
    },

    formatStatus(status) {
      switch (status) {
        case 0:
          return "待入账";
        case 1:
          return "已入账";
        case 2:
          return "已退款";
        case 3:
          return "入账异常";
        default:
          return "未知";
      }
    },

    // 格式化时间
    formatTime(timeStr) {
      if (!timeStr) return "";
      const date = new Date(timeStr);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      const h = String(date.getHours()).padStart(2, "0");
      const min = String(date.getMinutes()).padStart(2, "0");
      const s = String(date.getSeconds()).padStart(2, "0");
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    },
  },
};
</script>

<style scoped>
.my-serviceorder {
  width: 100%;
  min-height: 100vh;
  background: #f8f8f8;
  padding: 10px;
  box-sizing: border-box;
}

.device-list {
  display: flex;
  overflow-x: auto;
  margin-bottom: 12px;
}

.device-item {
  min-width: 90px;
  padding: 6px 8px;
  margin-right: 8px;
  background: #fff;
  border-radius: 8px;
  flex-shrink: 0;
  cursor: pointer;
  text-align: center;
  font-size: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.device-item.active {
  background: #1890ff;
  color: #fff;
  font-weight: bold;
}

.order-box {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
}

.order-num {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.order-detail {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-top: 1px solid #eee;
}

.detail-left {
  font-size: 12px;
  color: #333;
  width: 65%;
}

.detail-left .ms-box {
  margin-bottom: 4px;
}

.detail-right {
  text-align: center;
  color: #1890ff;
}

.jg-right {
  font-weight: 600;
  font-size: 16px;
}

.ms-right {
  font-size: 12px;
  color: #666;
}

.order-more {
  text-align: center;
  padding: 10px 0;
  color: #1890ff;
  font-size: 14px;
  cursor: pointer;
}

.empty-tip {
  text-align: center;
  color: #999;
  font-size: 14px;
  margin: 20px 0;
}
</style>
